<template>
  <div class="banner-page-view">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="banner-content">
            <div class="title"
                 :class="animateIndex === 0?'animated fadeInLeft': 'title'">
              <h4>{{bannerList[0].title}}</h4>
              <h5>{{bannerList[0].introduce}}</h5>
              <h6>{{bannerList[0].content}}</h6>
            </div>
            <img class="banner" :src="bannerList[0].banner" alt=""
                 :class="animateIndex === 0?'animated fadeInRight': 'banner'">
          </div>
        </div>
        <div class="swiper-slide">
          <div class="banner-content">
            <div class="title"
                 :class="animateIndex === 1?'animated fadeInLeft': 'title'">
              <h4>{{bannerList[1].title}}</h4>
              <h5>{{bannerList[1].introduce}}</h5>
              <h6>{{bannerList[1].content}}</h6>
            </div>
            <img class="banner" :src="bannerList[1].banner" alt=""
                 :class="animateIndex === 1?'animated fadeInRight': 'banner'">
          </div>
        </div>
        <div class="swiper-slide">
          <div class="banner-content">
            <div class="title"
                 :class="animateIndex === 2?'animated fadeInLeft': 'title'">
              <h4>{{bannerList[2].title}}</h4>
              <h5>{{bannerList[2].introduce}}</h5>
              <h6>{{bannerList[2].content}}</h6>
            </div>
            <img class="banner" :src="bannerList[2].banner" alt=""
                 :class="animateIndex === 2?'animated fadeInRight': 'banner'">
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  export default{
    name: 'BannerSwiper',
    data(){
      return {
        animateIndex:0
      };
    },
    props: {
      bannerList: Array
    },
    computed: {
    },
    components: {},
    methods: {
      bannerSwiper: function () {
        this.circulationSwiper = new Swiper('.swiper-container', {
          autoplay: 3000,
          // 分页器
          pagination: '.swiper-pagination',
          paginationClickable: true,
          observer:true,
          observeParents:true,
          autoplayDisableOnInteraction : false,
          onTransitionEnd: swiperbanner => {
            let index = swiperbanner.activeIndex;
            this.animateIndex = index;
          }
        });
      }
    },
    created: function () {
    },
    mounted: function () {
      this.bannerSwiper();
    }
  };
</script>
<style lang="scss" rel="stylesheet/scss">
  .banner-page-view{
    text-align: left;
    .swiper-container {
      width: 100%;
      .swiper-wrapper {
        .swiper-slide{
          position: relative;
          background:url('./image/banner.jpg');
          background-size: 100% 100%;
          .bannerImg {
            width:100%;
            height:752px;
            position: absolute;
            top:0;left:0;
            z-index:1;
          }
          .banner-content{
            width:1200px;
            height:752px;
            position: relative;
            margin:auto;
            top:100px;
            .title{
              position: absolute;
              top:0;left:-50px;
              color:$color-4;
              z-index:2;
              opacity:0;
              h4{
                font-size:48px;
                margin-top:190px;
              }
              h5{
                font-size:18px;
                margin-top:70px;
              }
              h6{
                font-size:18px;
                margin-top:20px;
              }
            }
            .titleActive{
              opacity:1;
            }
            .banner{
              position: relative;
              left:550px;
              opacity:0;
            }
          }
        }
      }

      .swiper-pagination {
        position: relative;
        top:-50px;
        .swiper-pagination-bullet {
          width:15px;
          height:15px;
          background: #aaacbc;
          opacity: 1;
          margin-left:20px;
        }
        .swiper-pagination-bullet-active {
          width:15px;
          height:15px;
          background: #ffb52f;
          opacity: 1;
        }
      }
    }
  }
</style>
